{
  "chat": {
    "title": "Discussion",
    "empty": "Aucune discussion pour le moment",
    "loadError": "Impossible de charger cette conversation",
    "messagePlaceholder": "Message",
    "typing": "{{name}} est en train d'écrire…",
    "typingTwo": "{{a}} et {{b}} sont en train d'écrire…",
    "typingMany": "Plusieurs personnes sont en train d'écrire…",
    "online": "En ligne",
    "offline": "Hors ligne",
    "unread": "Non lu",
    "startDm": "Envoyer un message à {{name}}",
    "members": "Membres",
    "mute": "Désactiver les notifications de cette conversation",
    "unmute": "Activer les notifications de cette conversation",
    "muted": "Notifications désactivées"
  },
  "login": {
    "title": "Bon retour !",
    "description": "Entrez votre adresse e-mail et nous vous enverrons un code de connexion.",
    "input": {
      "label": "Adresse e-mail",
      "placeholder": "me@email.com"
    },
    "button": {
      "label": "Demander un code",
      "loading": "Envoi du code..."
    }
  },
  "verify": {
    "title": "Entrer le code",
    "description": "Entrez le code que nous vous avons envoyé par e-mail à {{email}}.",
    "input": {
      "label": "Code de vérification",
      "placeholder": "00000000"
    },
    "button": {
      "label": "Vérifier le code",
      "loading": "Vérification du code..."
    },
    "buttonAbort": {
      "label": "Annuler"
    },
    "buttonResend": {
      "label": "Renvoyer le code"
    },
    "error": {
      "Invalid or expired OTP.": "Le code est expiré ou invalide.",
      "invalidOtp": "Le code est expiré ou invalide."
    }
  },
  "date": "{{value, datetime}}",
  "auth": {
    "logout": {
      "button": "Déconnexion",
      "confirmTitle": "Déconnexion",
      "confirmMessage": "Êtes-vous sûr de vouloir vous déconnecter ?",
      "error": "Échec de la déconnexion. Veuillez réessayer."
    }
  },
  "errors": {
    "types": {
      "authentication": "Erreur d'authentification",
      "network": "Problème de connexion",
      "generic": "Une erreur est survenue"
    },
    "messages": {
      "sessionExpired": "Votre session a expiré. Veuillez vous reconnecter.",
      "networkError": "Veuillez vérifier votre connexion internet et réessayer.",
      "genericError": "Une erreur inattendue s'est produite. Vous pouvez actualiser la page ou vous déconnecter.",
      "noOrg": "Aucune organisation trouvée..."
    },
    "technical": {
      "title": "Détails techniques :",
      "retryAttempts": "Tentatives : {{current}}/{{max}}"
    },
    "actions": {
      "tryAgain": "Réessayer",
      "loginAgain": "Se reconnecter",
      "logout": "Déconnexion",
      "moreOptions": "Plus d'options",
      "chooseAction": "Choisissez une action :",
      "refreshApp": "Actualiser l'application",
      "debugData": "Données de débogage",
      "clearCacheRetry": "Vider le cache et réessayer"
    }
  },
  "common": {
    "currency": "{{value, currency}}",
    "decimalSeparator": ",",
    "loading": "Chargement...",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "error": "Erreur",
    "success": "Succès",
    "time": {
      "dayAgo": "il y a 1 jour",
      "daysAgo": "il y a {{count}} jours",
      "weekAgo": "il y a 1 semaine",
      "weeksAgo": "il y a {{count}} semaines",
      "monthsAgo": "il y a {{count}} mois",
      "secondsAbbr": "s"
    },
    "profile": "Profil"
  },
  "dashboard": {
    "error": {
      "orgNotFound": "Organisation introuvable"
    },
    "quickActions": {
      "media": {
        "title": "Tous les médias",
        "subtitle": "Parcourir la bibliothèque"
      },
      "achievements": {
        "title": "Succès",
        "subtitle": "Voir la progression"
      },
      "profile": {
        "title": "Carte de membre",
        "subtitle": "Vos informations"
      },
      "membership": {
        "title": "Adhésion",
        "subtitle": "Voir le plan"
      },
      "offers": {
        "title": "Offres",
        "subtitle": "Parcourir les offres"
      },
      "invite": {
        "title": "Inviter des membres",
        "subtitle": "Créer un code QR"
      }
    },
    "sections": {
      "featuredVideos": "Vidéos en vedette",
      "lastViewed": "Vus récemment",
      "bookmarkedVideos": "Éléments enregistrés",
      "recentAchievements": "Succès récents",
      "viewAllAction": "Tout voir"
    }
  },
  "membership": {
    "paymentRequired": {
      "title": "Configuration du paiement requise",
      "subtitle": "Votre adhésion a été transférée vers cette organisation. Pour continuer, veuillez configurer votre paiement avec l'un des moyens de paiement disponibles.",
      "paidUntilNote": "Votre période déjà payée est conservée — vous ne serez pas débité avant le {{date}}.",
      "bonusOffer_one": "Configurez votre paiement avant le {{date}} et recevez {{count}} mois bonus gratuit.",
      "bonusOffer_other": "Configurez votre paiement avant le {{date}} et recevez {{count}} mois bonus gratuits.",
      "openDashboard": "Configurer le paiement dans le tableau de bord web",
      "openDashboardHint": "Pour des raisons de sécurité, la configuration du paiement s'effectue dans votre navigateur. Vous serez connecté automatiquement.",
      "checkAgain": "J'ai effectué le paiement",
      "error": "La configuration du paiement n'a pas pu être lancée. Veuillez réessayer."
    },
    "codeOfConduct": {
      "heading": "Code de conduite",
      "subtitle": "Veuillez lire le texte suivant et l’accepter pour continuer à utiliser cette organisation.",
      "acceptLabel": "J’ai lu et j’accepte « {{title}} ».",
      "accept": "Accepter",
      "acceptError": "Votre consentement n’a pas pu être enregistré. Veuillez réessayer.",
      "loadError": "Le texte n’a pas pu être chargé.",
      "retry": "Réessayer",
      "newVersion": "Une nouvelle version s’applique désormais. Veuillez la lire et l’accepter."
    },
    "title": "Adhésion",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "period": {
      "monthly": "Mensuel",
      "yearly": "Annuel"
    },
    "pricing": {
      "per": {
        "monthly": "par mois",
        "yearly": "par an"
      }
    },
    "sections": {
      "planDetails": "Détails",
      "organization": "Organisation"
    },
    "labels": {
      "billingPeriod": "Période de facturation",
      "memberSince": "Membre depuis",
      "validUntil": "Valable jusqu'au",
      "cancelled": "Abonnement annulé"
    },
    "organization": {
      "memberDescription": "Vous êtes membre de cette organisation"
    },
    "management": {
      "title": "Gérer votre abonnement",
      "description": "Pour modifier votre abonnement, veuillez utiliser l'application web OctaHub ou contacter {{organizationName}} directement."
    },
    "dashboard": {
      "title": "Ouvrir le tableau de bord",
      "subtitle": "Gérez votre abonnement et vos paramètres",
      "openError": "Impossible d'ouvrir le tableau de bord. Veuillez réessayer."
    }
  },
  "media": {
    "download": {
      "button": "Télécharger",
      "available": "Disponible hors ligne"
    },
    "screens": {
      "bookmarks": "Vidéos enregistrées",
      "lastViewed": "Vidéos vues récemment",
      "library": "Médias"
    },
    "bookmark": {
      "save": "Enregistrer",
      "saved": "Enregistré",
      "bookmarkLabel": "Favori",
      "bookmarkedLabel": "Enregistré"
    },
    "folder": {
      "itemCount_one": "{{count}} élément",
      "itemCount_other": "{{count}} éléments",
      "folderDescription": "Dossier avec {{count}} éléments"
    },
    "sharedFolders": {
      "upload": "Téléverser",
      "newFolder": "Nouveau dossier",
      "folderNamePlaceholder": "Nom du dossier...",
      "uploading": "Téléversement...",
      "uploadProgress": "{{progress}} %",
      "uploadSuccess": "Fichier téléversé avec succès",
      "uploadError": "Échec du téléversement",
      "uploadErrorMessage": "Une erreur s'est produite lors du téléversement. Veuillez réessayer.",
      "uploadSubtitle": "Téléverser un fichier dans ce dossier",
      "newFolderSubtitle": "Créer un nouveau sous-dossier"
    },
    "navigation": {
      "previous": "Précédent",
      "next": "Suivant"
    },
    "relatedVideos": "Contenu associé",
    "delete": {
      "button": "Supprimer",
      "confirmTitle": "Supprimer le média",
      "confirmMessage": "Êtes-vous sûr de vouloir supprimer cet élément ? Cette action est irréversible.",
      "success": "Média supprimé avec succès",
      "error": "Échec de la suppression",
      "errorMessage": "Impossible de supprimer ce média. Veuillez réessayer.",
      "errorInUse": "Ce média est utilisé dans une ou plusieurs offres et ne peut pas être supprimé."
    }
  },
  "achievements": {
    "title": "Succès",
    "subtitle": "Vos accomplissements",
    "count_zero": "Aucun succès obtenu",
    "count_one": "{{count}} succès obtenu",
    "count_other": "{{count}} succès obtenus",
    "earned": "Obtenu {{time}}",
    "emptyState": {
      "title": "Aucun succès pour le moment",
      "description": "Complétez des cours et des activités pour obtenir votre premier succès !"
    }
  },
  "noOrg": {
    "title": "Aucune organisation trouvée",
    "description": "Vous n'avez pas encore accès à une organisation. Veuillez contacter votre administrateur pour obtenir l'accès ou réessayez plus tard.",
    "actions": {
      "title": "Ce que vous pouvez faire :",
      "contactAdmin": "Contacter l'administrateur de votre organisation",
      "askInvitation": "Demander une invitation",
      "checkAccount": "Vérifier que vous utilisez le bon compte",
      "tryRelogin": "Essayer de vous déconnecter et reconnecter"
    }
  },
  "offers": {
    "title": "Offres",
    "detailsTitle": "Détails de l'offre",
    "notFound": "Offre introuvable",
    "notFoundMessage": "Cette offre est introuvable",
    "noOffers": "Aucune offre disponible pour le moment",
    "purchased": "Acheté",
    "free": "Gratuit",
    "purchaseWebOnly": "Achat uniquement via l'application web",
    "claimOffer": "Réclamer l'offre",
    "purchase": "Acheter",
    "purchasedBadge": "✓ Vous possédez déjà cette offre",
    "youOwnThis": "Vous avez accès à tout le contenu de cette offre",
    "missingAchievements": "⚠️ Vous n'avez pas les succès requis pour cette offre. Il vous manque encore : {{missing}}",
    "mobileNotAvailable": "⚠️ Les achats ne sont pas disponibles dans l'application mobile",
    "mobileNotAvailableSubtext": "Veuillez visiter notre site web pour acheter cette offre",
    "price": "Prix :",
    "includedContent": "Contenu inclus",
    "includedAchievements": "Succès inclus",
    "videoCount_one": "{{count}} vidéo",
    "videoCount_other": "{{count}} vidéos",
    "audioCount_one": "{{count}} audio",
    "audioCount_other": "{{count}} audios",
    "pdfCount_one": "{{count}} PDF",
    "pdfCount_other": "{{count}} PDF",
    "documentCount_one": "{{count}} document",
    "documentCount_other": "{{count}} documents",
    "imageCount_one": "{{count}} image",
    "imageCount_other": "{{count}} images",
    "achievementCount_one": "{{count}} succès",
    "achievementCount_other": "{{count}} succès",
    "paymentDenied": {
      "title": "Paiement indisponible",
      "description": "Cette offre n'est pas disponible à l'achat dans votre région"
    },
    "pricing": {
      "netAmount": "Montant net"
    },
    "errors": {
      "general": "Erreur",
      "purchaseFailed": "Échec du traitement de l'achat",
      "webOnly": "Les achats sont uniquement disponibles sur la version web"
    },
    "success": {
      "claimed": "Offre réclamée avec succès !"
    },
    "paymentProviders": {
      "selectTitle": "Choisir le mode de paiement",
      "selectSubtitle": "Choisissez comment vous souhaitez payer",
      "stripe": {
        "name": "Stripe",
        "description": "Carte de crédit, carte de débit, Apple Pay, Google Pay"
      },
      "paypal": {
        "name": "PayPal",
        "description": "Solde PayPal, carte de crédit, compte bancaire"
      }
    },
    "payment": {
      "processing": "Traitement de votre paiement...",
      "success": {
        "title": "Paiement réussi !",
        "message": "Votre achat a été effectué avec succès. Vous avez maintenant accès au contenu.",
        "viewOffer": "Voir l'offre",
        "backToOffers": "Retour aux offres"
      },
      "pending": {
        "title": "Paiement en cours",
        "message": "Votre paiement est encore en cours de traitement. Cela peut prendre quelques instants...",
        "checkStatus": "Vérifier le statut"
      },
      "failed": {
        "title": "Échec du paiement",
        "message": "Votre paiement n'a pas pu être finalisé. Veuillez réessayer.",
        "tryAgain": "Réessayer"
      }
    }
  },
  "orgSelection": {
    "title": "Sélectionner une organisation",
    "subtitle": "Choisissez une organisation pour continuer",
    "switchOrg": "Changer d'organisation",
    "switchOrgSubtitle": "Passer à une autre organisation",
    "currentOrg": "Actuelle"
  },
  "profile": {
    "myPurchases": "Mes achats",
    "idPrefix": "ID : "
  },
  "settings": {
    "language": {
      "title": "Langue",
      "subtitle": "Sélectionnez votre langue préférée",
      "systemDefault": "Par défaut du système"
    },
    "notifications": {
      "title": "Notifications",
      "subtitle": "Choisissez ce dont vous souhaitez être notifié",
      "chat": "Messages de discussion",
      "chatHint": "Soyez notifié des nouveaux messages dans vos conversations",
      "seeAll": "Voir toutes les notifications",
      "permissionDenied": "Les notifications de cette application sont désactivées dans les réglages de votre appareil."
    }
  },
  "openWebApp": "Ouvrir l'application web",
  "openWebAppSubtext": "Gérez votre compte, vos achats et plus encore sur {{url}}",
  "openWebAppError": "Impossible d'ouvrir l'application web. Veuillez réessayer.",
  "invite": {
    "title": "Inviter des membres",
    "selectPlan": "Sélectionner un plan d'adhésion",
    "selectGroup": "Sélectionner un groupe",
    "generating": "Génération en cours...",
    "scanToJoin": "Scannez ce code QR pour rejoindre",
    "createAnother": "Créer un autre",
    "error": {
      "createFailed": "Impossible de créer l'invitation. Veuillez réessayer.",
      "noPlans": "Aucun plan d'adhésion disponible."
    }
  },
  "notifications": {
    "title": "Notifications",
    "empty": "Aucune notification pour le moment",
    "markAllRead": "Tout marquer comme lu",
    "unread": "Non lu",
    "loadError": "Impossible de charger vos notifications",
    "chat": {
      "messageGroup": {
        "title": "{{channel}}",
        "body": "{{sender}}: {{preview}}"
      },
      "messageDm": {
        "title": "{{sender}}",
        "body": "{{preview}}"
      }
    },
    "common": {
      "newMessage": "Nouveau message"
    }
  }
}
